import { render, staticRenderFns } from "./BottleSizeView.vue?vue&type=template&id=dea1af7e"
import script from "./BottleSizeView.vue?vue&type=script&lang=ts"
export * from "./BottleSizeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports